export default __webpack_public_path__ + "static/media/Product-Sans-Regular.d1653840.ttf";